import log from 'loglevel';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PLAN_STATUS } from '../../../../consts/enums';
import { AttachMoney } from '../../../../icons/attach-money';
import { MoneyOff } from '../../../../icons/money-off';
import { X } from '../../../../icons/x';
import STRING_KEYS from '../../../../language/keys';
import { AccountTrialStatus } from './AccountTrialStatus/AccountTrialStatus';

const TAG = '[ACCOUNTS_TRIAL_PLAN]';

type AccountsTrialPlanProps = {
  plan: string,
  planDisplayName: string,
}

export const AccountsTrialPlan = ({
  plan,
  planDisplayName,
}: AccountsTrialPlanProps):JSX.Element => {
  const { t: translate } = useTranslation();

  switch (plan) {
    case PLAN_STATUS.TRIAL: {
      return (
        <AccountTrialStatus
          icon={ <MoneyOff color="warning.main" /> }
          text={ translate(STRING_KEYS.TRIAL) }
        />
      );
    }
    case PLAN_STATUS.TRIAL_ENDED: {
      return (
        <AccountTrialStatus
          icon={ <MoneyOff color="error.main" /> }
          text={ translate(STRING_KEYS.TRIAL_ENDED) }
        />
      );
    }
    case PLAN_STATUS.CANCELED: {
      return (
        <AccountTrialStatus
          icon={ <X color="action" /> }
          text={ translate(STRING_KEYS.CANCELLED) }
        />
      );
    }
    case PLAN_STATUS.PAID: {
      return (
        <AccountTrialStatus
          icon={ <AttachMoney color="success.main" /> }
          text={ translate(STRING_KEYS.PAID) }
          planDisplayName={ planDisplayName }
          paid
          // TO DO CHANGE FROM PROPS
        />
      );
    }
    case PLAN_STATUS.LITE: {
      return (
        <AccountTrialStatus
          icon={ <MoneyOff color="warning.main" /> }
          text={ translate(STRING_KEYS.LITE) }
          planDisplayName={ planDisplayName }
        />
      );
    }
    default: {
      log.warn(TAG, 'no such type of Plan');

      return <></>;
    }
  }
};
